import React from "react"
import { isBuildRunnerType, isIncrementalUpdate } from "../../shared/utils"
import useSiteCdnIntegrations from "../../../site/cdnIntegrations/hooks/useSiteCdnIntegrations"
import { SubscriptionStatus } from "@modules/graphql/types"
import { isProperlyConnected } from "@modules/site/cdnIntegrations"
import { NewBuildDetailsInfo } from "./NewBuildDetailsInfo"
import { useRollbacksAndManualDeploysAvailable } from "@modules/organization/shared/hooks/useRollbacksAndManualDeploysAvailable"

export function BuildDetailsInfo({
  buildStatus,
  previewUrl,
  createdAt,
  startedAt,
  endedAt,
  createdAtDate,
  deployStartedAt,
  deployEndedAt,
  duration,
  structuredBuild,
  commit,
  author,
  branch,
  buildType,
  runnerType,
  buildId,
  siteId,
  organizationId,
  repositoryUrl,
  source,
  cdnVendor,
  incrementalPreviewsEnabled,
  routeMetadata,
  metadata,
  pullRequest,
  buildUrl,
}) {
  const cdnIntegrations = useSiteCdnIntegrations(siteId, branch)
  const mainIntegration = cdnIntegrations.find(isProperlyConnected)
  const isBuildDetails = isBuildRunnerType(runnerType)
  const showDeploymentStatus = isBuildDetails && deployStartedAt
  const showCdnIntegrations =
    showDeploymentStatus && Boolean(mainIntegration) && isBuildDetails
  const showStructuredLogs =
    structuredBuild && buildStatus !== SubscriptionStatus.Canceled

  let displayPreviewURL = previewUrl

  if (runnerType === "PREVIEW" && incrementalPreviewsEnabled) {
    displayPreviewURL = `https://${buildUrl}`
  }

  const isEligiblePlan =
    useRollbacksAndManualDeploysAvailable(organizationId).result

  return (
    <NewBuildDetailsInfo
      buildId={buildId}
      siteId={siteId}
      organizationId={organizationId}
      runnerType={runnerType}
      buildStatus={buildStatus}
      showStructuredLogs={showStructuredLogs}
      commit={commit}
      buildType={buildType}
      source={source}
      isBuildDetails={isBuildDetails}
      previewUrl={displayPreviewURL}
      branch={branch}
      duration={duration}
      createdAt={createdAt}
      startedAt={startedAt}
      endedAt={endedAt}
      createdAtDate={createdAtDate}
      showDeploymentStatus={showDeploymentStatus}
      deployStartedAt={deployStartedAt}
      deployEndedAt={deployEndedAt}
      mainIntegration={mainIntegration}
      author={author}
      repositoryUrl={repositoryUrl}
      isIncrementalUpdate={isIncrementalUpdate(runnerType, buildType)}
      showCdnIntegrations={showCdnIntegrations}
      cdnVendor={cdnVendor}
      isEligiblePlan={isEligiblePlan}
      routeMetadata={routeMetadata}
      buildMetadata={metadata}
      pullRequest={pullRequest}
      buildUrl={buildUrl}
    />
  )
}
